/*=========================================================================================
  File Name: companies.js
  Description: Vuex store for fetching and storing companies
==========================================================================================*/
//imports
import axios from "axios";

// initial state
const state = {
  companies: [],
  isLoadingCompanies: false,
};

// getters
const getters = {
  getCompanies: (state) => {
    return state.companies;
  },
};

// actions
const actions = {
  fetchCompanies({ commit }) {
    this.isLoadingCompanies = true;
    return new Promise((resolve, reject) => {
      axios
        .get("api/Companies")
        .then((res) => {
          setTimeout(() => resolve(res.data), 1500);
          commit("FETCH_COMPANIES", res.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          this.isLoadingCompanies = true;
        });
    });
  },
  fetchToyotaCompanies({ commit }) {
    this.isLoadingCompanies = true;
    return new Promise((resolve, reject) => {
      axios
        .get("api/Companies/toyota")
        .then((res) => {
          setTimeout(() => resolve(res.data), 250);
          commit("FETCH_COMPANIES", res.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          this.isLoadingCompanies = true;
        });
    });
  },
};

// mutations
const mutations = {
  FETCH_COMPANIES(state, data) {
    state.companies = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
